// Centre de la séance de décision pour un mandat à ordonnancer (lot L4-B) : liquidation, facture,
// engagement et ligne budgétaire, servis par GET /depense/liquidations/:id.
import type { LiquidationDepense } from '@cc/contrats';
import { EtatErreur, Squelette } from '@cc/ui';
import { useQuery } from '@tanstack/react-query';
import { requete } from '../../api/client';
import { date as formaterDate } from '../../commun/format';
import styles from './decisions.module.css';

const francs = (n: number) => `${n.toLocaleString('fr-FR')} F`;

export function VignetteLiquidation({ id }: { id: string }) {
  const fiche = useQuery({ queryKey: ['depense', 'liquidation', id], queryFn: ({ signal }) => requete<LiquidationDepense>(`/depense/liquidations/${id}`, { signal }) });
  if (fiche.isLoading) return <Squelette lignes={6} />;
  if (fiche.isError || !fiche.data) return <EtatErreur message="La liquidation n'a pas pu être chargée." onReessayer={() => void fiche.refetch()} />;
  const l = fiche.data;
  return (
    <article className={styles.dossier} aria-live="polite">
      <div className={styles.enTete}>
        <p className="cc-etiquette">Mandat à ordonnancer · dépense</p>
        <h2>{l.engagement.tiers} : {francs(l.montant)}</h2>
        <div className={styles.meta}>
          <span className="cc-mono">{l.numero}</span>
          <span>Engagement {l.engagement.numero ?? ''} ({francs(l.engagement.montant)})</span>
          <span>Ligne {l.ligne.code} · {l.ligne.libelle}</span>
          <span>Liquidée le {formaterDate(l.liquide.le)}{l.liquide.nom ? ` par ${l.liquide.nom}` : ''}</span>
        </div>
      </div>
      <section className={styles.bloc}>
        <h3>Facture</h3>
        <p>
          {l.facture.fournisseur_nom}, facture {l.facture.numero_fournisseur} du {formaterDate(l.facture.date_facture)} : {francs(l.facture.montant)}
          {l.situation ? ' (situation de travaux)' : ''}
        </p>
      </section>
      <section className={styles.bloc}>
        <h3>Contrôle</h3>
        <p className={styles.sans}>Le compte qui a engagé la dépense ne peut pas l&apos;ordonnancer (séparation des fonctions contrôlée en base).</p>
      </section>
    </article>
  );
}
